export default __webpack_public_path__ + "static/media/filmCriticMovie.ce222fbb.png";